import { useQuery } from '@tanstack/react-query';
import { getProductsStatus } from '../api/productsStatus/getProductsStatus';
import { ProductsStatusResponse } from '@/@types/productsStatus';

type ProductsStatusResult = {
  areProductLoading: boolean;
  areProductsRefetching: boolean;
  productsStatus?: ProductsStatusResponse;
  isProductsStatusError?: boolean;
};

export const useGetProductsStatus = (enabled = true): ProductsStatusResult => {
  const { isLoading, data, isError, isRefetching } = useQuery({
    queryKey: ['products-status'],
    queryFn: getProductsStatus,
    enabled,
  });

  return {
    areProductLoading: isLoading,
    areProductsRefetching: isRefetching,
    isProductsStatusError: isError,
    productsStatus: data,
  };
};
